import React from "react";

const ComponentField = (props) => {
  const { component, className } = props;

  return (
    <div className={`component-field-container ${className}`}>{component}</div>
  );
};

export default ComponentField;
